import { QuestionType } from './questionType';
import { CourseStatus } from './courseStatus';
import { ChoiceAnswerType } from './choiceAnswerType';
import { CircleNumberType } from './circleNumberType';
import { entryNumber } from './entryValue';
import { DayOfWeekType } from './dayOfWeekType';

export {
	QuestionType,
	CourseStatus,
	ChoiceAnswerType,
	CircleNumberType,
	entryNumber,
	DayOfWeekType,
}


// WEBPACK FOOTER //
// ./src/app/services/Enums/index.ts